import { atom } from "jotai";

import { TimeLookbackType } from "@shared/types";

export const tlrTypeAtom = atom<TimeLookbackType>("Last opened");
